const generateBfzArticleFaqData = (article_content) => {
  let article_faq = {}

  const valid_answer_types = ["paragraph", "list"]

  article_content.forEach((item, index) => {
    if (item.type.startsWith("heading") && item.content.slice(-1) === "?") {
      const valid_answer_node = article_content
        .slice(index + 1)
        ?.find((node) => valid_answer_types.includes(node.type))

      const faq_answer = !!valid_answer_node ? valid_answer_node.content : null

      Object.assign(article_faq, {
        [item.content]: faq_answer,
      })
    }
  })

  return article_faq
}

module.exports = generateBfzArticleFaqData
